import { useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

export const useAdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/admin/users`, { credentials: 'include' });
      if (response.ok) {
        setUsers(await response.json() || []);
      }
    } catch (err) {
      console.error('Failed to fetch users:', err);
      setError('Не удалось загрузить пользователей');
    } finally {
      setLoading(false);
    }
  }, []);

  const banUser = useCallback(async (userId, reason, duration) => {
    try {
      await fetch(`${API_URL}/admin/users/${userId}/ban`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ reason, duration })
      });
      await fetchUsers();
      return { success: true };
    } catch (err) {
      console.error('Failed to ban user:', err);
      return { success: false, error: 'Не удалось забанить пользователя' };
    }
  }, [fetchUsers]);

  const unbanUser = useCallback(async (userId) => {
    try {
      await fetch(`${API_URL}/admin/users/${userId}/unban`, {
        method: 'POST',
        credentials: 'include'
      });
      await fetchUsers();
      return { success: true };
    } catch (err) {
      console.error('Failed to unban user:', err);
      return { success: false, error: 'Не удалось разбанить пользователя' };
    }
  }, [fetchUsers]);

  const setTunnelLimit = useCallback(async (userId, limit) => {
    try {
      await fetch(`${API_URL}/admin/users/${userId}/limit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ limit })
      });
      await fetchUsers();
      return { success: true };
    } catch (err) {
      console.error('Failed to set limit:', err);
      return { success: false, error: 'Не удалось изменить лимит' };
    }
  }, [fetchUsers]);

  const setPlan = useCallback(async (userId, plan, duration) => {
    try {
      await fetch(`${API_URL}/admin/users/${userId}/plan`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ plan, duration })
      });
      await fetchUsers();
      return { success: true };
    } catch (err) {
      console.error('Failed to set plan:', err);
      return { success: false, error: 'Не удалось изменить план' };
    }
  }, [fetchUsers]);

  const toggleAdmin = useCallback(async (userId, adminLevel) => {
    try {
      await fetch(`${API_URL}/admin/users/${userId}/admin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ is_admin: adminLevel > 0, admin_level: adminLevel })
      });
      await fetchUsers();
      return { success: true };
    } catch (err) {
      console.error('Failed to toggle admin:', err);
      return { success: false, error: 'Не удалось изменить права' };
    }
  }, [fetchUsers]);

  return {
    users,
    loading,
    error,
    fetchUsers,
    banUser,
    unbanUser,
    setTunnelLimit,
    setPlan,
    toggleAdmin
  };
};